import React from 'react';
import { Droplets, Wrench, Shield, Filter, TestTube, Clock } from 'lucide-react';
import { Button } from './ui/button';

const ICON_MAP = { Droplets, Wrench, Shield, Filter, TestTube, Clock };

const DEFAULT_SERVICES = [
  { icon: 'Droplets', title: 'RO Installation', price: 'From ₹500', description: 'Professional installation with warranty for all brands' },
  { icon: 'Wrench', title: 'RO Repair & Service', price: 'From ₹300', description: 'Quick repair for leakage, low flow, bad taste & more' },
  { icon: 'Shield', title: 'AMC Packages', price: 'From ₹1,999/yr', description: 'Annual maintenance with free filter cleaning & support' },
  { icon: 'Filter', title: 'Filter Replacement', price: 'From ₹400', description: 'Genuine filters for all brands with installation' },
  { icon: 'TestTube', title: 'Water Testing', price: 'Free', description: 'TDS testing to know your water quality' },
  { icon: 'Clock', title: 'Emergency RO Services', price: '3200', description: '24/7 emergency repair across Jaipur' },
];

const Services = ({ cms }) => {
  const d = cms || {};
  const title = d.title || 'Our Expert Services';
  const subtitle = d.subtitle || 'What We Offer';
  const cmsServices = d.services || DEFAULT_SERVICES;

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-16 md:py-24 bg-gray-50 reveal-on-scroll" data-testid="services-section">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <p className="text-xs sm:text-sm font-semibold text-blue-700 uppercase tracking-wider mb-3">{subtitle}</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
            {title.includes(' ') ? <>{title.split(' ').slice(0, -1).join(' ')} <span className="text-blue-700">{title.split(' ').pop()}</span></> : title}
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5 max-w-5xl mx-auto">
          {cmsServices.map((svc, i) => {
            const Icon = ICON_MAP[svc.icon] || Droplets;
            return (
              <div key={i} className="group bg-white border border-gray-200 hover:border-blue-200 rounded-xl p-4 sm:p-6 hover:shadow-lg transition-all cursor-pointer"
                onClick={scrollToContact} data-testid={`service-card-${i}`}>
                <div className="p-2.5 bg-blue-50 rounded-lg inline-flex mb-3 group-hover:bg-blue-100 transition-colors">
                  <Icon className="text-blue-700" size={20} />
                </div>
                <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-1 group-hover:text-blue-700 transition-colors">{svc.title}</h3>
                <p className="text-xs sm:text-sm text-gray-500 mb-3 hidden sm:block leading-relaxed">{svc.description}</p>
                <div className="text-xs sm:text-sm font-bold text-lime-600">{svc.price}</div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 sm:mt-14 text-center bg-white rounded-2xl p-6 sm:p-10 max-w-3xl mx-auto border border-gray-200 shadow-sm">
          <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-2">{d.cta_title || 'Need Emergency RO Repair?'}</h3>
          <p className="text-xs sm:text-sm text-gray-500 mb-5 max-w-md mx-auto">{d.cta_description || 'Same-day service available 24/7 across Jaipur with genuine spare parts.'}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={scrollToContact} data-testid="services-book-btn" className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-5 rounded-xl font-semibold">{d.cta_button_text || 'Book Service Now'}</Button>
            <a href={`tel:${(d.emergency_phone || '+919887068888').replace(/\s/g, '')}`} data-testid="services-emergency-call" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-blue-700 border-2 border-blue-200 px-6 py-5 rounded-xl font-semibold transition-colors">
              <Clock size={18} /> {d.emergency_label || 'Emergency Call'}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
